import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { AdminUser } from 'src/types/shared/AdminUser';
import { ChallengeApplicationResponse } from 'src/types/shared/Challenge';

export const revokeAdminMfaRequest = createAction('revokeAdminMfaRequest');
export const revokeAdminMfaSuccess = createAction<AdminUser>('revokeAdminMfaSuccess');
export const revokeAdminMfaFailure = createAction('revokeAdminMfaFailure');

export const revokeAdminMfa =
    (id: number) =>
    async (dispatch: AppDispatch): Promise<void> => {
        dispatch(revokeAdminMfaRequest());
        try {
            const { data }: UpdateAdminResponse = await api.patch(
                `admin/admins/${id}/revoke-mfa`,
                null,
            );

            dispatch(revokeAdminMfaSuccess(data.user));
        } catch (e) {
            handleApiErrors(dispatch, revokeAdminMfaFailure, e);
        }
    };

interface AdminUserResponse {
    user: AdminUser;
    challengeApplications: ChallengeApplicationResponse[];
}
interface UpdateAdminResponse {
    data: AdminUserResponse;
}
